
import { mapGetters } from 'vuex'

import seoTags from "@/mixins/seoTags";

export default {
	mixins: [seoTags],
	computed: {
		...mapGetters({
			benefitsCredit: 'benefits/benefitsCredit',
			benefitsCredit_slider: 'benefits/benefitsCredit_slider',
			benefits_autoCredit: 'benefits/benefits_autoCredit'

		}),
	},

	mounted() {
		setTimeout(function () { window.scrollTo(0, -100); }, 1);
	},
}
